export default class JoinActivityUseCase {
  constructor(postRepository) {
    this.postRepository = postRepository;
  }

  async execute({ postId, userId, participantData, currentParticipants, currentDetails }) {
    if (!postId || !userId) {
      throw new Error('Post ID and User ID are required');
    }

    if (!participantData) {
      throw new Error('Participant data is required');
    }

    try {
      const result = await this.postRepository.toggleParticipation(postId, {
        currentParticipants,
        currentDetails,
        participantData
      });

      if (!result.success) {
        return result;
      }
      
      return result;
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to join activity'
      };
    }
  }
} 